var _ = require('../util')

// This is the elementDirective that handles <content>
// transclusions. It relies on the raw content of an
// instance being stored as `$options._content` during
// the transclude phase.

module.exports = {

  bind: function () {
    var vm = this.vm
    var contentOwner = vm
    // we need find the content owner, which is the closest
    // non-inline-repeater instance.
    while (contentOwner.$options._repeat) {
      contentOwner = contentOwner.$parent
    }
    var raw = contentOwner.$options._content
    var content
    if (!raw) {
      this.fallback()
      return
    }
    var parent = contentOwner.$parent
    var selector = this.el.getAttribute('select')
    if (!selector) {
      // Default content
      var self = this
      var compileDefaultContent = function () {
        self.compile(
          extractFragment(raw.childNodes, raw, true),
          contentOwner.$parent,
          vm
        )
      }
      if (!contentOwner._isCompiled) {
        // defer until the end of instance compilation,
        // because the default outlet must wait until all
        // other possible outlets with selectors have picked
        // out their contents.
        contentOwner.$once('hook:compiled', compileDefaultContent)
      } else {
        compileDefaultContent()
      }
    } else {
      // select content
      selector = vm.$interpolate(selector)
      var nodes = raw.querySelectorAll(selector)
      if (nodes.length) {
        content = extractFragment(nodes, raw)
        if (content.hasChildNodes()) {
          this.compile(content, parent, vm)
        } else {
          this.fallback()
        }
      } else {
        this.fallback()
      }
    }
  },

  fallback: function () {
    this.compile(_.extractContent(this.el, true), this.vm)
  },

  compile: function (content, owner, host) {
    if (content && owner) {
      this.unlink = owner.$compile(content, host)
    }
    if (content) {
      _.replace(this.el, content)
    } else {
      _.remove(this.el)
    }
  },

  unbind: function () {
    if (this.unlink) {
      this.unlink()
    } 
  }
}

/**
 * Extract qualified content nodes from a node list.
 *
 * @param {NodeList} nodes
 * @param {Element} parent
 * @param {Boolean} main
 * @return {DocumentFragment}
 */

function extractFragment (nodes, parent, main) {
  var frag = document.createDocumentFragment()
  for (var i = 0, l = nodes.length; i < l; i++) {
    var node = nodes[i]
    // if this is the main outlet, we want to skip all
    // previously selected nodes;
    // otherwise, we want to mark the node as selected.
    // clone the node so the original raw content remains
    // intact. this ensures proper re-compilation in cases
    // where the outlet is inside a conditional block
    if (main && !node.selected) {
      frag.appendChild(node.cloneNode(true))
    } else if (!main && node.parentNode === parent) {
      node.selected = true
      frag.appendChild(node.cloneNode(true))
    }
  }
  return frag
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/compiler/content.js
 ** module id = 51
 ** module chunks = 0
 **/